import { render, staticRenderFns } from "./CadBandeira.vue?vue&type=template&id=3b6bf1da&"
import script from "./CadBandeira.vue?vue&type=script&lang=js&"
export * from "./CadBandeira.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports